// extracted by mini-css-extract-plugin
module.exports = {"h2":"Title-module--h2--2YtZy"};